














































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class LayoutComponent extends Vue {
  name: "layout"
  constructor() {
    super();
     //console.log("LayoutComponent created");
  }
  
  
}
